import { DatePicker, Input } from '@trackman/web-shared-components';

import { AppButton } from 'components/form';
import { AppUseIcon } from 'components/ui';
import { FilterType } from '../FilterType';
import InputAdornment from '@mui/material/InputAdornment';
import { t } from 'utilities/TranslationUtils';
import { useState } from 'react';

type DateRangeFilterProps = {
  filter: FilterType;
  onApply: (value) => void;
};

export const DateRangeSeparatePickersFilter = ({ filter, onApply }: DateRangeFilterProps) => {
  if (filter.type !== 'date-range-separate-pickers') return <></>;

  const [startDate, setStartDate] = useState<Date | null>(null);
  const [endDate, setEndDate] = useState<Date | null>(null);

  const [isStartDateCalendarOpen, setIsStartDateCalendarOpen] = useState(false);
  const [isEndDateCalendarOpen, setIsEndDateCalendarOpen] = useState(false);

  const handleClearDateRange = (e: React.MouseEvent<HTMLElement>, setState: (date: Date | null) => void) => {
    e.stopPropagation();
    setState(null);
  };

  return (
    <div className='data-table-filter-content gap-10px'>
      <div className='date_range_filter position-relative z-index-9 d-flex gap-1'>
        <DatePicker
          open={isStartDateCalendarOpen}
          label={t('common.start_date')}
          value={startDate}
          maxDate={endDate || undefined}
          onChange={(date) => {
            setStartDate(date);
            setIsStartDateCalendarOpen(false);
          }}
          disableOpenPicker
          renderInput={(props) => (
            <Input
              {...props}
              className='no-helper-text'
              autoComplete='off'
              disabled
              onClick={() => {
                setIsStartDateCalendarOpen(true);
                setIsEndDateCalendarOpen(false);
              }}
              onKeyDown={(e) => e.key === 'Enter' && onApply([startDate, endDate])}
              InputProps={{
                readOnly: true,
                endAdornment: (
                  <InputAdornment position='end'>
                    {startDate && !isStartDateCalendarOpen ? (
                      <button className='btn btn-transparent p-0 scale-7' onClick={(e) => handleClearDateRange(e, setStartDate)}>
                        <AppUseIcon name='CloseModalIcon' height='14' width='14' />
                      </button>
                    ) : null}
                  </InputAdornment>
                ),
              }}
            />
          )}
        />

        <DatePicker
          open={isEndDateCalendarOpen}
          label={t('common.end_date')}
          value={endDate}
          minDate={startDate || undefined}
          onChange={(date) => {
            setEndDate(date);
            setIsEndDateCalendarOpen(false);
          }}
          disableOpenPicker
          renderInput={(props) => (
            <Input
              {...props}
              className='no-helper-text'
              autoComplete='off'
              disabled
              onClick={() => {
                setIsEndDateCalendarOpen(true);
                setIsStartDateCalendarOpen(false);
              }}
              onKeyDown={(e) => e.key === 'Enter' && onApply([startDate, endDate])}
              InputProps={{
                readOnly: true,
                endAdornment: (
                  <InputAdornment position='end'>
                    {endDate && !isEndDateCalendarOpen ? (
                      <button className='btn btn-transparent p-0 scale-7' onClick={(e) => handleClearDateRange(e, setEndDate)}>
                        <AppUseIcon name='CloseModalIcon' height='14' width='14' />
                      </button>
                    ) : null}
                  </InputAdornment>
                ),
              }}
            />
          )}
        />
      </div>

      <AppButton
        data-test='ApplyFilterSubmit'
        type='button'
        className='apply-button '
        variant='primary'
        onClick={() => onApply([startDate, endDate])}
      >
        {t('common.apply')}
      </AppButton>
    </div>
  );
};

export default DateRangeSeparatePickersFilter;
